class SortBy extends HTMLElement {
  constructor() {
    super();
    this.sortBy = this.sortBy.bind(this);
  }

  sortBy() {
    this.inputs = this.querySelectorAll(".input-sort");

    if (!this.inputs.length) return;

    Shopify.queryParams = {};

    if (window.location.search.length) {
      const params = window.location.search.substr(1).split("&");

      for (const param of params) {
        const [key, value] = param.split("=").map(decodeURIComponent);

        if (key && value) {
          Shopify.queryParams[key] = value;
        }
      }
    }

    this.inputs.forEach((el) => {
      el.addEventListener("change", ({ target }) => {
        const { value } = target;

        Shopify.queryParams.sort_by = value;
        window.location.search = new URLSearchParams(
          Shopify.queryParams
        ).toString();
      });
    });
  }

  connectedCallback() {
    this.sortBy();
  }
}

const init = () => {
  if (!customElements.get("sort-by")) {
    customElements.define("sort-by", SortBy);
  }
};

init();
